<template>

  <b-card v-if="ticket.child_tickets && ticket.child_tickets.length > 0">

    <table class="table table-tickets">
      <thead>
        <tr>
          <th></th>
          <th :style="{'color': event.phcolor}">Sub-Ticket Name</th>

          <th v-if="hasEarlyBird" :style="earlyBirdValid ? {'color': event.phcolor} : {'color': 'gray',  'text-decoration': 'line-through'}">
            Early Bird Cost ({{event.vat_exclusive ? 'exc' : 'inc'}} VAT)
            <el-popover style="display:inline-block" placement="top-start" title="Dates Valid" width="200" trigger="hover" :content="earlyBirdInfo">
              <div slot="reference">
                <i class="fa fa-lg fa-info-circle"></i>
              </div>
            </el-popover>
          </th>

          <th v-if="hasPaidTickets" :style="earlyBirdValid && hasEarlyBird ? {'color': 'gray'} : {'color': event.phcolor}">
            Cost ({{event.vat_exclusive ? 'exc' : 'inc'}} VAT)
            <el-popover v-if="earlyBirdValid" style="display:inline-block" placement="top-start" title="Dates Valid" width="200" trigger="hover" :content="earlyBirdInfoExp">
              <div slot="reference">
                <i class="fa fa-lg fa-info-circle"></i>
              </div>
            </el-popover>
          </th>

          <th v-if="vatable">VAT Amount</th>
          <th v-if="vatable">Total to Pay</th>
          <th :style="{color: event.phcolor}" v-if="event.show_tickets_remaining">Tickets Remaining</th>
          <th :style="{color: event.phcolor}">Ticket Date & Time</th>
          <th :style="{color: event.phcolor}">Number of tickets</th>
        </tr>
      </thead>
      <!-- <pre>Adjustment for other: {{adjustmentForBooked}}</pre> -->
      <child-ticket v-for="(childTicket, idx) in ticket.child_tickets" v-on:setTicket="assignTicket" :key="idx" :event="event" :attendee="attendee" :ticket="childTicket" :disabled="disabled"></child-ticket>
    </table>
  </b-card>
</template>

<script>
import childTicketRow from "@/book/main_booking/child-ticket-row.vue";
import ticketMixins from "@/book/main_booking/tickets-mixin.js";
// import moment from "moment";
import EventBus from "../../events/event-bus";
import {mapGetters} from 'vuex';

export default {
  props: ["event", "ticket", "attendee", "disabled"],

  mixins: [ticketMixins],

  components: {
    childTicket: childTicketRow
  },

  data() {
    return {
      regUser: null,
      assignedTicket: {},
      assignedNumber: 0,
      // adjustmentForBooked: 0
    };
  },

  created() {
    this.regUser = this.attendee.registered_user_attributes;
    if (!this.regUser.assign_subtickets_attributes) {
      this.regUser.assign_subtickets_attributes = [];
    }
  },

  computed: {
    ...mapGetters({
      hasPaidTickets: 'getChargeable'
    })
  },

  methods: {
    assignTicket(childTicket, quantity_tickets) {
      var self = this;
      if (quantity_tickets > 0) {
        this.assignedTicket = {
          package_id: childTicket.id,
          quantity_assigned: quantity_tickets,
          attendee_idx: this.attendee.idx
        };

        this.regUser.assign_subtickets_attributes.push(this.assignedTicket);

        this.$store.commit("setAssignedChildTicket", this.assignedTicket);
      } else {
        var subIndex = -1;
        this.regUser.assign_subtickets_attributes.forEach(function(
          subTicketAssigned,
          idx
        ) {
          if (
            (subTicketAssigned.package_id =
              childTicket.id &&
              subTicketAssigned.attendee_idx == self.attendee.idx)
          ) {
            subIndex = idx;
            self.$store.commit("removeAssignedChildTicket", subTicketAssigned);
          }
        });
        if (subIndex > -1) {
          this.regUser.assign_subtickets_attributes.splice(subIndex, 1);
        }
      }

      EventBus.$emit("setTicket", childTicket);
    }
  }
};
</script>

